var it = Object.defineProperty;
var T = (i) => {
  throw TypeError(i);
};
var ot = (i, t, e) => t in i ? it(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var h = (i, t, e) => ot(i, typeof t != "symbol" ? t + "" : t, e), U = (i, t, e) => t.has(i) || T("Cannot " + e);
var s = (i, t, e) => (U(i, t, "read from private field"), e ? e.call(i) : t.get(i)), r = (i, t, e) => t.has(i) ? T("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(i) : t.set(i, e), c = (i, t, e, o) => (U(i, t, "write to private field"), o ? o.call(i, e) : t.set(i, e), e);
import st from "postmate";
var n = /* @__PURE__ */ ((i) => (i.initialized = "initialized", i.themeOverridesApplied = "themeOverridesApplied", i.cssOverridesApplied = "cssOverridesApplied", i.baseThemeUpdated = "baseThemeUpdated", i.message = "message", i.oauthSuccess = "oauthSuccess", i.oauthFailed = "oauthFailed", i.oauthCanceled = "oauthCanceled", i.resetSession = "resetSession", i.updateBrand = "updateBrand", i))(n || {}), d = /* @__PURE__ */ ((i) => (i.initialize = "initialize", i.scriptLog = "scriptLog", i.requestOauth = "requestOauth", i.success = "success", i.error = "error", i))(d || {}), V, Y, Z, tt, et, S, b, N, m;
et = d.scriptLog, tt = d.success, Z = d.error, Y = d.requestOauth, V = d.initialize;
class rt {
  constructor() {
    r(this, S);
    r(this, b);
    r(this, N);
    h(this, "listeners", {});
    r(this, m, (t, e) => {
      var o;
      (o = this.listeners[t]) == null || o.forEach((u) => {
        u(e);
      });
    });
    h(this, "on", (t, e) => {
      var o;
      this.listeners[t] = this.listeners[t] || [], (o = this.listeners[t]) == null || o.push(e);
    });
    h(this, et, (t) => {
      var e;
      (e = s(this, S)) == null || e.emit(d.scriptLog, t);
    });
    h(this, tt, (t) => {
      var e;
      (e = s(this, S)) == null || e.emit(d.success, JSON.stringify(t));
    });
    h(this, Z, (t) => {
      var e;
      (e = s(this, S)) == null || e.emit(d.error, JSON.stringify(t));
    });
    h(this, Y, (t) => {
      var e;
      (e = s(this, S)) == null || e.emit(d.requestOauth, t);
    });
    h(this, V, async () => (c(this, S, await new st.Model({
      [n.message]: (t) => {
        s(this, m).call(this, n.message, t);
      },
      [n.oauthSuccess]: (t) => {
        s(this, m).call(this, n.oauthSuccess, t);
      },
      [n.oauthFailed]: (t) => {
        s(this, m).call(this, n.oauthFailed, t);
      },
      [n.oauthCanceled]: (t) => {
        s(this, m).call(this, n.oauthCanceled, t);
      },
      [n.resetSession]: (t) => {
        s(this, m).call(this, n.resetSession, t);
      },
      [n.updateBrand]: (t) => {
        s(this, m).call(this, n.updateBrand, t);
      },
      [n.initialized]: ({
        origin: t,
        url: e,
        script: o,
        options: u
      }) => {
        c(this, b, t), c(this, N, e), s(this, m).call(this, n.initialized, {
          origin: t,
          url: e,
          script: o,
          options: u
        });
      }
    })), this));
  }
}
S = new WeakMap(), b = new WeakMap(), N = new WeakMap(), m = new WeakMap();
const K = 650, W = 750, X = 375, j = 375, Q = {
  logo: "https://storage.googleapis.com/pluto-brand-assets/assets/default-app.svg",
  name: "App Name"
}, M = {
  frame: "https://frame.pluto.xyz",
  notary: "https://notary.pluto.xyz",
  socket: "wss://notary.pluto.xyz"
};
var l, a, v, x, y, f, g, E, A, F, H, $, L, _, P, B, J, z;
class nt {
  constructor() {
    r(this, l, {
      preferOauthPopup: !0,
      brand: Q,
      endpoints: M
    });
    r(this, a);
    r(this, v);
    r(this, x, !1);
    r(this, y, !1);
    r(this, f);
    r(this, g);
    r(this, E, async () => {
      var I, G, R, q;
      const t = new URLSearchParams(window.location.search), e = t.get("code"), o = t.get("state"), u = t.get("error"), D = t.get("error_description");
      t.get("error_uri");
      const p = localStorage.getItem("pluto-oauth"), k = window.opener !== null;
      if (u)
        return s(this, l).preferOauthPopup && k ? (localStorage.setItem(
          "pluto-oauth-error",
          JSON.stringify({
            error: u,
            errorDescription: D || "OAuth authorization was denied",
            isProviderError: !0
          })
        ), s(this, z).call(this), !0) : (await this.connect(""), (I = s(this, a)) == null || I.call(n.oauthFailed, {
          error: u,
          errorDescription: D || "OAuth authorization was denied",
          isProviderError: !0
        }), !0);
      if (e && o || p)
        if (s(this, l).preferOauthPopup && e && o && k)
          localStorage.setItem("pluto-oauth", JSON.stringify({ code: e, state: o })), s(this, z).call(this);
        else {
          const w = p ? JSON.parse(p) : { code: e, state: o };
          return w.code && w.state && localStorage.removeItem("pluto-oauth"), await this.connect(""), (G = s(this, a)) == null || G.call(n.oauthSuccess, {
            code: e || w.code,
            state: o || w.state
          }), !0;
        }
      const O = localStorage.getItem("pluto-oauth-error");
      if (O) {
        const w = JSON.parse(O);
        return localStorage.removeItem("pluto-oauth-error"), await this.connect(""), w.isProviderError ? (R = s(this, a)) == null || R.call(n.oauthFailed, w) : (q = s(this, a)) == null || q.call(n.oauthCanceled, w), !0;
      }
      return !1;
    });
    r(this, A, () => new Promise((t) => {
      s(this, f) || c(this, f, setInterval(() => {
        document.getElementById("pluto-frame") && (clearInterval(s(this, f)), t(!0));
      }, 50));
    }));
    r(this, F, (...t) => {
      console.debug("PlutoSDK:", ...t);
    });
    r(this, H, () => {
      var t, e, o, u;
      (t = s(this, a)) == null || t.on(d.scriptLog, s(this, $)), (e = s(this, a)) == null || e.on(d.requestOauth, s(this, P)), (o = s(this, a)) == null || o.on(d.success, s(this, L)), (u = s(this, a)) == null || u.on(d.error, s(this, _));
    });
    r(this, $, (t) => {
      var e, o;
      (o = (e = s(this, v)) == null ? void 0 : e.onScriptLog) == null || o.call(e, t);
    });
    r(this, L, (t) => {
      var e, o;
      (o = (e = s(this, v)) == null ? void 0 : e.onSuccess) == null || o.call(e, JSON.parse(t));
    });
    r(this, _, (t) => {
      var e, o;
      (o = (e = s(this, v)) == null ? void 0 : e.onError) == null || o.call(e, JSON.parse(t));
    });
    r(this, P, (t) => {
      if (s(this, l).preferOauthPopup) {
        const u = (window.screen.width - 430) / 2, D = (window.screen.height - 780) / 2, p = window.open(
          t,
          "pluto-oauth",
          `width=430,height=780,left=${u},top=${D}`
        );
        p != null && p.focus && (p == null || p.focus());
        let k = !1;
        c(this, g, setInterval(async () => {
          await s(this, E).call(this) && (k = !0, clearInterval(s(this, g)), c(this, g, void 0), O && clearInterval(O));
        }, 20));
        const O = setInterval(() => {
          p != null && p.closed && (clearInterval(O), setTimeout(() => {
            var I;
            k || (s(this, g) && (clearInterval(s(this, g)), c(this, g, void 0)), (I = s(this, a)) == null || I.call(n.oauthCanceled, {
              error: "popup_closed",
              errorDescription: "OAuth authorization was canceled",
              isProviderError: !1
            }));
          }, 100));
        }, 500);
      } else
        window.location.href = t;
    });
    r(this, B, async () => {
      var u;
      const t = document.createElement("style");
      document.head.appendChild(t), t.appendChild(
        document.createTextNode(`
      /* ------------- base styles ----------------- */
      .pluto-frame--hidden {
        opacity: 0;
        position: fixed;
        left: -9999999px;
      }
      .pluto-frame {
        border: none;
        overflow: hidden;
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
        border-radius: 15px;
        background:#fff;
        height: clamp(${K}px, 50vh, ${W}px);
        width:  clamp(${X}px, 75vw, ${j}px);
        min-height:${K}px;
        min-width:${X}px;
        max-height:${W}px;
        max-width:${j}px;
      }

      /* ------------- mobile override ----------------------------- */
      @media (max-width: 767px) {
        .pluto-frame {
          position: fixed !important;
          inset: 0 !important;
          width: 100vw !important;
          min-width: 100vw !important;
          max-width: 100vw !important;
          height: 100dvh !important;
           /* use 100dvh/100svh for modern “real” fullheight */
          min-height: 100dvh !important;
          max-height: 100dvh !important;
          border-radius: 0 !important;
          filter: none !important;
          z-index: 1000 !important;

        }
      }
    `)
      );
      const e = document.getElementById("pluto-frame");
      console.log("this.#options.endpoints", s(this, l).endpoints), c(this, a, await new st({
        container: e,
        url: s(this, l).endpoints.frame,
        name: "pluto",
        classListArray: ["pluto-frame--hidden", "pluto-frame"]
      })), s(this, H).call(this);
      const { classList: o } = (u = s(this, a)) == null ? void 0 : u.frame;
      o.remove("pluto-frame--hidden"), s(this, J).call(this);
    });
    h(this, "send", (t, e) => {
      var o;
      (o = s(this, a)) == null || o.call(t, e);
    });
    h(this, "updateBrand", (t = s(this, l).brand) => {
      var e;
      s(this, l).brand = t, (e = s(this, a)) == null || e.call(n.updateBrand, t);
    });
    h(this, "updateEndpoints", (t) => {
      s(this, l).endpoints = { ...s(this, l).endpoints, ...t };
    });
    h(this, "initialize", async (t, e = {
      brand: Q,
      endpoints: M
    }) => {
      if (!s(this, x))
        return c(this, x, !0), c(this, l, {
          ...s(this, l),
          ...e,
          endpoints: { ...M, ...e.endpoints }
        }), c(this, v, t), await s(this, E).call(this), this;
    });
    h(this, "connect", async (t) => {
      var e;
      s(this, y) || (await s(this, A).call(this), await s(this, B).call(this), s(this, F).call(this, "Connecting to child frame from parent page"), console.log("options", s(this, l)), (e = s(this, a)) == null || e.call(n.initialized, {
        origin: window.origin,
        url: window.location.href,
        script: t === "" ? void 0 : t,
        options: s(this, l)
      }), c(this, y, !0));
    });
    r(this, J, () => {
      window.top, window.self;
    });
    r(this, z, () => {
      setTimeout(() => {
        window.close();
      }, 100);
    });
    return this;
  }
  isConnected() {
    return s(this, y);
  }
  isInitialized() {
    return s(this, x);
  }
  async resetConnection() {
    try {
      s(this, a) && s(this, a).call(n.resetSession), await new Promise((t) => setTimeout(t, 50)), s(this, a) && (s(this, a).destroy(), c(this, a, void 0)), c(this, y, !1), s(this, f) && (clearInterval(s(this, f)), c(this, f, void 0));
    } catch (t) {
      console.error("Error resetting connection:", t);
    }
  }
}
l = new WeakMap(), a = new WeakMap(), v = new WeakMap(), x = new WeakMap(), y = new WeakMap(), f = new WeakMap(), g = new WeakMap(), E = new WeakMap(), A = new WeakMap(), F = new WeakMap(), H = new WeakMap(), $ = new WeakMap(), L = new WeakMap(), _ = new WeakMap(), P = new WeakMap(), B = new WeakMap(), J = new WeakMap(), z = new WeakMap();
var at = /* @__PURE__ */ ((i) => (i.OPEN = "open", i.MESSAGE = "message", i.ERROR = "error", i.CLOSE = "close", i))(at || {});
class ut {
  constructor(t) {
    h(this, "socket", null);
    h(this, "url");
    h(this, "eventHandlers", {
      open: [],
      message: [],
      error: [],
      close: []
    });
    this.url = t;
  }
  connect(t) {
    try {
      this.socket = new WebSocket(`${this.url}?session_id=${t}`), this.socket.onopen = (e) => this.handleOpen(e), this.socket.onmessage = (e) => this.handleMessage(e), this.socket.onerror = (e) => this.handleError(e), this.socket.onclose = (e) => this.handleClose(e);
    } catch (e) {
      console.error("Error connecting to WebSocket:", e);
    }
  }
  disconnect() {
    this.socket && (this.socket.close(), this.socket = null, sessionStorage.removeItem("pluto-session-id"));
  }
  status() {
    return this.socket ? this.socket.readyState : WebSocket.CLOSED;
  }
  ack(t) {
    this.socket && this.socket.send(JSON.stringify({ id: t }));
  }
  send(t, e) {
    this.socket && this.socket.send(JSON.stringify({ id: t, message: e }));
  }
  on(t, e) {
    this.eventHandlers[t].push(e);
  }
  off(t, e) {
    this.eventHandlers[t] = this.eventHandlers[t].filter(
      (o) => o !== e
    );
  }
  handleMessage(t) {
    this.eventHandlers.message.forEach(
      (e) => e(t)
    );
  }
  handleError(t) {
    this.eventHandlers.error.forEach(
      (e) => e(t)
    );
  }
  handleClose(t) {
    sessionStorage.removeItem("pluto-session-id"), this.eventHandlers.close.forEach(
      (e) => e(t)
    );
  }
  handleOpen(t) {
    this.eventHandlers.open.forEach(
      (e) => e(t)
    );
  }
}
const ht = typeof window < "u";
let C;
ht ? C = window.top === window.self ? new nt() : new rt() : C = new Proxy(
  {},
  {
    get() {
      throw new Error(
        "`@plutoxyz/frame-js` is a client-side only SDK and cannot run in a server environment. Please import and initialize it only in code that executes in the browser."
      );
    }
  }
);
const dt = C;
export {
  rt as Child,
  d as ChildToParentEvents,
  M as DEFAULT_ENDPOINTS,
  n as ParentToChildEvents,
  nt as PlutoSDK,
  ut as WebSocketClient,
  at as WebSocketEvent,
  dt as default
};
//# sourceMappingURL=frame-js.es.js.map
